// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TotalBalance_wrapper_1sZcM"};